/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Breadcrumb, Divider, Row, Spin, message} from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import Routes from '../../routing/routes';
import userService from '../../services/userService'
import IssueTicketDetails from '../../components_new/issue-tracker-ticket-form';
import IssueCustomerBenefitsAndRevenue from '../../components_new/issue-tracker-customer-benefits-revenue';
import issueTrackerServices from '../../services/issueTrackerServices';
import IssueEditTicket from '../../components_new/issue-tracker-edit-ticket';

import IssueDetailsCard from '../../components_new/issue-tracker-details-card';
import IssueBenefitsCard from '../../components_new/issue-tracker-customer-benefits-card';

import authStore from '../../store/authStore';
import constants from '../../config/constants';
import Utils from '../../helpers/Utility';
import sensorboxGroupService from '../../services/sensorboxGroupService';
import { goToInsightsTicketsList } from '../../helpers/insightsTicketsNav';
import Permissions from '../../config/permssions';

const IssueTrackerDetails: React.FC = () => {

  let history = useHistory();
  const location = useLocation() as any;

  const system_id = new URLSearchParams(location?.search).get('system_id');
  const group_id = new URLSearchParams(location?.search).get('group_id');
  const status = new URLSearchParams(location?.search).get('status');
  const alert_description = new URLSearchParams(location?.search).get('alert_description');
  const alert_code = new URLSearchParams(location?.search).get('alert_code');
  const alert_color = new URLSearchParams(location?.search).get('alert_color');
  const issue_priority = new URLSearchParams(location?.search).get('issue_priority');
  const alert_log_id = new URLSearchParams(location?.search).get('alert_log_id');
  const orgCondition = authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)

  const ticket_id = new URLSearchParams(location?.search).get('ticket_id');
  const org_id = new URLSearchParams(location?.search).get('org_id') as string;

  const [issueDetails, setIssueDetails] = useState<any>({})
  const [softSavings, setSoftSavings] = useState<any>([])
  const [orgAdminUsers, setOrdAdminUsers] = useState<any>([])
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [skeletonOn, setSkeletonOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [issueId, setIssueId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [imageList, setImageList] = useState([])
  const [imageNotes, setImageNotes] = useState([])
  const [imageCreatedBy, setImageCreatedBy] = useState([{createdBy: '', createdAt: ''}])
  const [contractorList, setContractorList] = useState([]);
  const [technicianUnderContractor, setTechnicianUnderContractor] = useState([]);

  useEffect(() => {
    if (system_id || group_id) {
      fetchSystemDetails()
    } else if (ticket_id) {
      fetchIssueDetailsWithId(ticket_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [system_id, group_id, ticket_id])

  const fetchSystemDetails = async () => {
    try {
      setLoading(true)
      
      let datas = {
        alert_status: status,
        alert_code: alert_code || null,
        alert_description: alert_description || null,
        issue_priority: issue_priority || null,
        alert_color: alert_color || null,
        alert_log_id: alert_log_id || null
      } as any

      if (group_id) {
        // Handle asset group case
        datas.group_id = group_id

        let resp = await sensorboxGroupService.getSensorboxGroupById(group_id, org_id)
        let sensorBoxGroupDetails = resp.data
        datas.system_name = sensorBoxGroupDetails?.name
        datas.consumer    = sensorBoxGroupDetails?.consumer ? sensorBoxGroupDetails?.consumer : null
        datas.contractor  = sensorBoxGroupDetails?.contractor ? sensorBoxGroupDetails?.contractor : null
        datas.address     = sensorBoxGroupDetails?.sensorboxes[0]?.place ? sensorBoxGroupDetails?.sensorboxes[0]?.place : null
        
        setContractorList(sensorBoxGroupDetails?.contractor)
        if (sensorBoxGroupDetails?.consumer.length > 0) {
          let customerDetails = await userService.getUserByID(sensorBoxGroupDetails?.consumer[0]._id)
          datas.phone = customerDetails.phone_number || null
          datas.email = customerDetails.email || null
        }
      } else {
        // Handle individual sensor box case
        let sensorBoxDetails = await userService.getSensorBoxList(system_id as any)
        datas.sensor_box  = system_id
        datas.system_name = sensorBoxDetails?.alias ? sensorBoxDetails?.alias : sensorBoxDetails?.sensor_box_name;
        datas.consumer    = sensorBoxDetails?.consumer ? sensorBoxDetails?.consumer : null
        datas.contractor  = sensorBoxDetails?.contractor ? sensorBoxDetails?.contractor : null
        datas.address     = sensorBoxDetails?.place ? sensorBoxDetails?.place : null

        setContractorList(sensorBoxDetails?.contractor)
        if (sensorBoxDetails?.consumer.length > 0) {
          let customerDetails = await userService.getUserByID(sensorBoxDetails?.consumer[0]._id)
          datas.phone = customerDetails.phone_number || null
          datas.email = customerDetails.email || null
        }
      }

      setIssueDetails(datas)
      setLoading(false)

    } catch (error) {
      setLoading(false)
      message.destroy()
      message.error(error?.response?.data?.message)
    }
  }

  const imageData = async (issueDetails: any) => {
    try{
      setSkeletonOn(true)
      let notes: any = []
      let creatorDetails: any = []
      if (issueDetails && issueDetails?.notes) {
        let attachmentsResponse = issueDetails?.notes?.map(
          async (note: any) => {
            notes.push(note?.text);
            creatorDetails.push({createdBy: note?.creator_name, createdAt: note?.dateAdded})
            if (note?.attachments?.length) {
              let res: any = await Promise.all(
                (note?.attachments || []).map(async (element: any) => {
                  return await issueTrackerServices.getAttachedImageByimageId(
                    element
                  );
                })
              );
              let urls = res?.map((item: any) => {
                if (item && item?.data) {
                let url = URL.createObjectURL(item?.data);
                return url;
                }
              });

              return urls;
            }
          }
        );
        const responses: any = await Promise.all(attachmentsResponse);
        setImageList(responses)
        setImageNotes(notes)
        setImageCreatedBy(creatorDetails)
        setSkeletonOn(false)
    }
  } catch (error) {
      setSkeletonOn(false)
  }
  }

  const fetchIssueDetailsWithId = async (id: any) => {
    try {
      setLoading(true)

      let issuesTracker = await issueTrackerServices.IssueTrackerDetailsById(id, org_id)

      let customer_datas : any = {
        address: null
      }
      if (issuesTracker?.issue?.group_id) {
        let resp = await sensorboxGroupService.getSensorboxGroupById(issuesTracker?.issue?.group_id?._id, org_id)
        let sensorBoxGroupDetails = resp.data
        issuesTracker.issue.system_name = sensorBoxGroupDetails?.name
        setContractorList(sensorBoxGroupDetails?.contractor)
        if (sensorBoxGroupDetails?.consumer.length > 0) {
          let customerDetails = await userService.getUserByID(sensorBoxGroupDetails?.consumer[0]._id)
          customer_datas.phone = customerDetails.phone_number || null
          customer_datas.email = customerDetails.email || null
        }
      } else {
        let sensorBoxDetails = await userService.getSensorBoxList(issuesTracker?.issue?.sensor_box?._id as any)
        issuesTracker.issue.system_name = sensorBoxDetails?.alias ? sensorBoxDetails?.alias : sensorBoxDetails?.sensor_box_name;
        setContractorList(sensorBoxDetails?.contractor)
        customer_datas.address     = sensorBoxDetails?.place ? sensorBoxDetails?.place : null
        if (sensorBoxDetails?.consumer.length > 0) {
          let customerDetails = await userService.getUserByID(sensorBoxDetails?.consumer[0]._id)
          customer_datas.phone = customerDetails.phone_number || null
          customer_datas.email = customerDetails.email || null
        }
      }

      let softSavingsDetails = await issueTrackerServices.getSoftSavingsCategory()
      setSoftSavings(softSavingsDetails?.softSavings)

      const technicianList = authStore?.currentUser?.active_role?.role_type === constants.role.Contractor ? true : false
      let orgAdminList = await userService.getUserBasedOnRoleType(org_id, constants.role.Contractor, technicianList)
      setOrdAdminUsers(technicianList ? orgAdminList.result : orgAdminList)
      setTechnicianUnderContractor(technicianList ? orgAdminList?.technicianList : [])

      let datas = { ...issuesTracker.issue, ...customer_datas }
      setIssueDetails(datas)
      imageData(datas)
      setLoading(false)
    } catch (error: any) {
      const errorData = error?.response?.data
        const isUnauthorizedIssue = Utils.issueTrackerErrorHandler(errorData, constants.responseCode.unAuthorized, constants.message.issue_allocation_changed, constants.message.issue_doesnot_exist)
        if (isUnauthorizedIssue) {
            message.destroy()
            await message.error(error?.response?.data?.message)
            goToInsightsTicketsList(history, location);
            setLoading(false)
        } else {
            message.destroy()
            message.error(error?.response?.data?.message || constants.message.internalServerError)
            setLoading(false)
        }
    }

  }

  const onClickBreadCrumpItem = () => {
    goToInsightsTicketsList(history, location);
  }

  const onCreateTicket = async (values: any) => {
    setIsLoading(true)
    try {
      let datas = {
        sensor_box: issueDetails?.sensor_box || null,
        group_id: issueDetails?.group_id || null,
        contractor: values?.contractor || null,
        alert_status: issueDetails?.alert_status,
        alert_code: values?.diagnostic_code || issueDetails?.alert_code || null,
        category: values?.category || constants.defaultIssueTrackerCategory,
        created_on: values?.created_on || Date.now(),
        issue_title: values?.issue_title,
        issue_priority: values?.issue_priority,
        issue_description: values?.issue_description,
        components: values?.components,
        recommended_action: values?.recommended_action,
        timeframe: values?.timeframe,
        planned_completion_date: values?.planned_completion_date ?? null,
      }

      let issues = await issueTrackerServices.addIssueTrackerDetails(datas, org_id)
      let issue_id = (issues as any)?.data?.id
      setIssueId(issue_id)
      
      message.destroy()
      message.success("Successfully Created Ticket")

      let params = `?ticket_id=${issue_id}`

      if (orgCondition) {
        params += `&org_id=${org_id}`
      }
      setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    } catch (error) {
      setIsLoading(false)
      message.destroy()
      message.error(error?.response?.data?.message)
    }
  }

  const onClickCancelTicket = () => {
    goToInsightsTicketsList(history, location);
  }

  const onResolveTicket = async (values: any, action: any) => {
    try {
      let issues;
      setLoading(true)
      if (action === "savechanges") {
        issues = await issueTrackerServices.saveChangesIssue(issueDetails?.issue_id, values, org_id)
        message.destroy()
        message.success("Successfully Saved Ticket")
      } else {
        issues = await issueTrackerServices.resolveIssue(issueDetails?.issue_id, values, org_id)
        message.destroy()
        message.success((issueDetails?.status === "OPEN") ? "Successfully Completed Diagnosis" :  "Successfully Resolved Ticket")
      }

      fetchIssueDetailsWithId(issues?.id)
      setLoading(false)

    } catch (error: any) {
      const errorData = error?.response?.data
      const isUnauthorizedIssue = Utils.issueTrackerErrorHandler(errorData, constants.responseCode.unAuthorized, constants.message.issue_allocation_changed, constants.message.issue_doesnot_exist)
      if (isUnauthorizedIssue) {
          message.destroy()
          await message.error(error?.response?.data?.message)
          goToInsightsTicketsList(history, location);
          setLoading(false)
      } else {
          message.destroy()
          message.error(error?.response?.data?.message)
          setLoading(false)
      }
    }
  }

  const onMarkAsMissed = async () => {
    try {
      setLoading(true)
      await issueTrackerServices.updateIssueTrackerDetails(
        issueDetails?._id,
        {
          ...issueDetails,
          status: "MISSED",
          status_updated_at: Date.now()
        },
        org_id
      )
      message.destroy()
      message.success("Successfully marked as missed")
      fetchIssueDetailsWithId(issueDetails?._id)
      setLoading(false)
    } catch (error: any) {
      const errorData = error?.response?.data
      const isUnauthorizedIssue = Utils.issueTrackerErrorHandler(errorData, constants.responseCode.unAuthorized, constants.message.issue_allocation_changed, constants.message.issue_doesnot_exist)
      if (isUnauthorizedIssue) {
          message.destroy()
          await message.error(error?.response?.data?.message)
          goToInsightsTicketsList(history, location);
          setLoading(false)
      } else {
          message.destroy()
          message.error(error?.response?.data?.message || constants.message.internalServerError)
          setLoading(false)
      }
    }
  }
  const onCreateSubTicket = async () => {
        let orgid = org_id

        let params = ''
        if (group_id) {
          params = `?group_id=${issueDetails?.group_id}`
        } else {
          params = `?system_id=${issueDetails?.sensor_box}`
        }

        if(authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)){
            params += `&org_id=${orgid}`
        }

        history.push({
            pathname: `${Routes.issuetrackerdetails}`,
            search: params,
            state: location.state,
          });
  }


  const onCloseTicket = async (values: any, action: any) => {
    try {
      let issues;
      setLoading(true)

      if (action === "savechanges") {
        issues = await issueTrackerServices.saveChangesIssue(issueDetails?.issue_id, values, org_id)
        message.destroy()
        message.success("Successfully Saved Ticket")
      } else {
        issues = await issueTrackerServices.closeIssue(issueDetails?.issue_id, values, org_id)
        message.destroy()
        message.success("Successfully Closed Ticket")
      }

      fetchIssueDetailsWithId(issues?.id)
      setLoading(false)

    } catch (error: any) {
      const errorData = error?.response?.data
      const isUnauthorizedIssue = Utils.issueTrackerErrorHandler(errorData, constants.responseCode.unAuthorized, constants.message.issue_allocation_changed, constants.message.issue_doesnot_exist)
      if (isUnauthorizedIssue) {
          message.destroy()
          await message.error(error?.response?.data?.message)
          goToInsightsTicketsList(history, location);
          setLoading(false)
      } else {
          message.destroy()
          message.error(error?.response?.data?.message)
          setLoading(false)
      }
    }
  }

  const onIgnoreTicket = async () => {
    try {
      setLoading(true)
      let data = {
        ignored_by: authStore?.currentUser?.uid
      }

      await issueTrackerServices.ignoreIssue(issueDetails?.issue_id, data, org_id)
      message.destroy()
      message.success("Successfully Ignored Ticket")

      goToInsightsTicketsList(history, location);

      setLoading(false)

    } catch (error) {
      setLoading(false)
      message.destroy()
      message.error(error?.response?.data?.message)
    }
  }

  const onEditTicket = () => {
    setEditModalVisible(true)
  }

  const onDelete = () => {
    //do nothing
  }

  const onClickEditCancel = () => {
    setEditModalVisible(false)
    fetchIssueDetailsWithId(ticket_id)
  }

  const onDeleteTicket = async () => {
    try {
      setLoading(true)
      await issueTrackerServices.deleteIssue(issueDetails?._id, org_id)
      message.destroy()
      message.success("Successfully Deleted Ticket")
      setLoading(false)
      goToInsightsTicketsList(history, location);

    } catch (error) {
      setLoading(false)
      message.destroy()
      message.error(error?.response?.data?.message)
    }
  }

  const handleEditTicket = async (values: any, issueId?: any) => {
    try {
      setLoading(true)
      const updateData = {
        ...values,
        alert_code: values?.diagnostic_code || null,
        category: values?.category || constants.defaultIssueTrackerCategory,
        created_on: values?.created_on || issueDetails?.created_on || Date.now(),
        contractor: values?.contractor || null,
        planned_completion_date: values?.planned_completion_date ?? null,
        status: values?.status,
        status_updated_at: values?.status_updated_at,
      }
      let issues = await issueTrackerServices.updateIssueTrackerDetails(issueId ? issueId :  issueDetails?._id, updateData, org_id)
      message.destroy()
      message.success(constants.message.edit_ticket_success)
      setEditModalVisible(false)

      await fetchIssueDetailsWithId(issues?.id)
      setLoading(false)
    } catch (error: any) {
      const errorData = error?.response?.data
      const isUnauthorizedIssue = Utils.issueTrackerErrorHandler(errorData, constants.responseCode.unAuthorized, constants.message.issue_allocation_changed, constants.message.issue_doesnot_exist)
      if (isUnauthorizedIssue) {
          setEditModalVisible(false)
          message.destroy()
          await message.error(error?.response?.data?.message)
          goToInsightsTicketsList(history, location);
          setLoading(false)
      } else {
          message.destroy()
          await message.error(error?.response?.data?.message)
          setLoading(false)
      }
    }
  }

  return (
    <div className="p-0">
      <Spin spinning={loading}>
        <div className="d-flex flex-column h-100 overflow-hidden p-0">
          <div className="flex-fill h-100 issue-tracker-padding">
            <div className="d-flex">
              <div className="flex-fill p-0 m-2">
                <Breadcrumb className='mb-4' separator=">" >
                  <Breadcrumb.Item onClick={onClickBreadCrumpItem} className='ant-badge-count-sm'>
                    <a href="/" onClick={(e: any) => { e.preventDefault(); }}>Insights / Tickets</a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{(system_id || group_id) ? `Create Ticket` : issueDetails?.issue_id}</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </div>
            <div className="d-lg-flex">
              <div className="flex-custom-fill mr-md-2">
                <div className="d-flex flex-column h-100">
                  <div className="flex-fill">
                  </div>
                  <div className="flex-auto">
                    <Row gutter={[16, 16]}>
                    {(system_id || group_id) &&

                      <>
                      <div className='p-2'>
                          <p className="font-w-600" style={{ fontSize: "16px" }}>Customer</p>
                          <p className="pt-1 paragraph">
                            {issueDetails?.consumer && issueDetails?.consumer?.length && issueDetails?.consumer[0] ? issueDetails?.consumer[0]?.name
                              : `None`}
                          </p>
                        </div><Divider
                            type="vertical" className='mr-3'/><div className='p-2'>
                            <p className="font-w-600" style={{ fontSize: "16px" }}>Address</p>
                            <p className="pt-1 paragraph" style={{width: "300px"}}>
                              {issueDetails?.address ? issueDetails?.address : `None`}
                            </p>
                          </div><Divider
                            type="vertical" className='mr-3'/><div className='p-2'>
                            <p className="font-w-600" style={{ fontSize: "16px" }}>Phone</p>
                            <p className="pt-1 paragraph">
                              {issueDetails?.phone ? issueDetails?.phone : `None`}
                            </p>
                          </div><Divider
                            type="vertical" className='mr-3'/><div className='p-2'>
                            <p className="font-w-600" style={{ fontSize: "16px" }}>Email</p>
                            <p className="pt-1 paragraph">
                              {issueDetails?.email ? issueDetails?.email : `None`}
                            </p>
                          </div><Divider
                            type="vertical" className='mr-5'/>
                  </>
                }

                      {(system_id || group_id) &&
                        authStore?.currentUser?.access?.includes(Permissions.create_edit_issue_tracker) &&
                        <IssueTicketDetails
                          issueDetails={issueDetails?.status === 'INCOMPLETE' ? [] : issueDetails}
                          onCreateTicket={(values: any) => onCreateTicket(values)}
                          onClickEdit={(values: any, issueId?: any) => handleEditTicket(values, issueId)}
                          onClickCancel={onClickCancelTicket}
                          onDelete={onDelete}
                          issueId={issueId}
                          isLoading={isLoading}
                          org_id={org_id}
                          contractorList={contractorList}
                        />
                      }

                      {ticket_id &&
                        <IssueDetailsCard
                          issueDetails={issueDetails}
                          onEditTicket={onEditTicket}
                          contractorList={contractorList} 
                          fetchIssueDetailsWithId={() => fetchIssueDetailsWithId(issueDetails?._id)}
                          imageList={imageList}
                          imageNotes={imageNotes}
                          imageCreatedBy={imageCreatedBy}
                          skeletonOn={skeletonOn}
                          ticket_id={ticket_id}
                          onClickCancelTicket={onClickCancelTicket}
                          onMarkAsMissed={onMarkAsMissed}
                          onIgnoreTicket={onIgnoreTicket}
                          onResolveTicket={(values: any, action: any) => onResolveTicket(values, action)}
                          onCreateSubTicket={() => onCreateSubTicket()}
                          technicianUnderContractor={technicianUnderContractor}
                          />
                      }

                      <IssueEditTicket
                        visible={editModalVisible}
                        issueDetails={issueDetails}
                        onClickCancel={onClickEditCancel}
                        onDelete={onDeleteTicket}
                        onClickEdit={(values: any) => handleEditTicket(values)}
                        contractorList={contractorList}
                      />


                      {(ticket_id && (issueDetails?.status === "RESOLVED")) && (authStore?.isOrgAdmin()) &&
                        <IssueCustomerBenefitsAndRevenue
                          issueDetails={issueDetails}
                          onCloseTicket={(datas: any, action: any) => onCloseTicket(datas, action)}
                          softSavingsOptions={softSavings}
                          orgAdminUsers={orgAdminUsers}
                          onCancel={onClickCancelTicket}
                        />
                      }

                      {ticket_id && issueDetails?.status === "CLOSED" &&
                        <IssueBenefitsCard
                          issueDetails={issueDetails}
                          orgAdminUsers={orgAdminUsers}
                        />
                      }

                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
}
export default IssueTrackerDetails;